import { Deserializable } from '../protocols/deserializable';

export class EndUserLicenceAgreement implements Deserializable {
  public id!: number;
  public licenceAgreement!: string;

  onDeserialize() {}
}
